import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, extensionGroupDetailFeatureKey } from './extension-group-detail.reducer';

export const extensionGroupDetailFeature = createFeatureSelector<State>(extensionGroupDetailFeatureKey);

export const getExtensionGroup = createSelector(extensionGroupDetailFeature, (state) => {
   return state.extensionGroup;
});

export const getExtensionGroupCallState = createSelector(extensionGroupDetailFeature, (state) => {
   return state.callState;
});

export const selectExtensionGroupDetailState = createFeatureSelector<State>(extensionGroupDetailFeatureKey);

export const selectQueryComplete = createSelector(
   selectExtensionGroupDetailState,
   (state: State) => state.queryComplete
);
